export default "__VITE_ASSET__CLDkdl$p__";